
export const DYNAMIC_LOADER_CONSTANTS = {
    finderCamapign: 'finder-campaign',
    finderDetail: 'finder-detail',
    routeData: 'svc',
};
